import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  icon?: ReactNode;
}
export function Button({
  children,
  href,
  onClick,
  className = '',
  icon
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 bg-brown text-white px-8 py-4 rounded-full font-sans font-bold text-lg transition-all duration-300 hover:bg-brown-dark hover:shadow-soft hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-accent/30';
  const content = <>
      {children}
      {icon && <span className="ml-2" data-id="element-296">{icon}</span>}
    </>;
  if (href) {
    const isExternal = href.startsWith('http');
    return <a href={href} className={`${baseStyles} ${className}`} onClick={onClick} {...isExternal ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} data-id="element-297">
        {content}
      </a>;
  }
  return <button onClick={onClick} className={`${baseStyles} ${className}`} data-id="element-298">
      {content}
    </button>;
}